import { useCallback } from 'react';
import {
	DRIFT_CUSTOM_WALLET_OPTIONS,
	DriftWalletName,
} from 'src/constants/wallets';
import Env from 'src/environmentVariables/EnvironmentVariables';
import useTryConnectAppKit from 'src/hooks/useTryConnectAppKit';
import { ReownWalletButton } from '../Wallets/AppKit/ReownWalletButton';
import { WalletConnectWalletButton } from '../Wallets/AppKit/WalletConnectWalletButton';
import { MagicLinkButton } from './MagicLinkButton';

export const EmailWalletsList = (props: {
	onChooseWallet: (walletName: DriftWalletName) => void;
}) => {
	const handleReownWalletConnectedCb = useCallback(() => {
		props.onChooseWallet(
			DRIFT_CUSTOM_WALLET_OPTIONS.APPKIT_WALLET_ADAPTER_NAME
		);
	}, [props.onChooseWallet]);

	useTryConnectAppKit(handleReownWalletConnectedCb);

	return (
		<>
			{Env.showAppKitWallet && <ReownWalletButton />}
			<WalletConnectWalletButton />
			{<MagicLinkButton onChooseWallet={props.onChooseWallet} />}
		</>
	);
};
